import { WindowRef } from '../../../Apps/Models/WindowRef';
import { LocalizedTranslation } from './Models/LocalizedTranslation';

export default class LocalizationService {
  private static instance: LocalizationService;
  private localizedTranslation: LocalizedTranslation = {};

  private constructor() {
    const localizedStrings = (window as WindowRef).Support.workspaceLocalization;
    if (localizedStrings) {
      this.localizedTranslation = localizedStrings as LocalizedTranslation;
    }
  }

  public static getInstance = () => {
    if (!LocalizationService.instance) {
      LocalizationService.instance = new LocalizationService();
    }

    return LocalizationService.instance;
  };

  /**
   * Fetch the localized content, if it exists
   */
  public getLocalizedResource = (value: string): string => {
    return this.localizedTranslation[value] ?? value;
  };
}
